import { api } from "@/lib/api";

/**
 * One configured `(remote_prefix → local_prefix)` rewrite. The
 * importer applies the longest-matching `remote_prefix` to a path
 * before opening it, so users with split host/container layouts
 * (NZBGet on a host, arr-in-one in a container) can translate the
 * download client's view of the path to arr-in-one's view. See
 * issue #18 + `crates/core/src/path_mapping.rs`.
 */
export interface PathMappingRow {
  id: number;
  remote_prefix: string;
  local_prefix: string;
  /** download_clients.id; null = applies to every download client. */
  applies_to: number | null;
  /** User-controlled tie-breaker when two rules match same prefix length. */
  ord: number;
}

export interface CreatePathMappingRequest {
  remote_prefix: string;
  local_prefix: string;
  applies_to?: number | null;
  ord?: number | null;
}

export interface UpdatePathMappingRequest {
  remote_prefix?: string;
  local_prefix?: string;
  /**
   * Tri-state: omit the key to leave alone, set to a number to scope to
   * a client, or set to null to clear (make global). The Rust side uses
   * a custom serde deserializer so missing != explicit null.
   */
  applies_to?: number | null;
  ord?: number;
}

export const pathMappingsApi = {
  list: () => api<PathMappingRow[]>("/api/v1/path-mappings"),
  create: (body: CreatePathMappingRequest) =>
    api<PathMappingRow>("/api/v1/path-mappings", {
      method: "POST",
      body: JSON.stringify(body),
    }),
  update: (id: number, body: UpdatePathMappingRequest) =>
    api<PathMappingRow>(`/api/v1/path-mappings/${id}`, {
      method: "PATCH",
      body: JSON.stringify(body),
    }),
  remove: (id: number) =>
    api<void>(`/api/v1/path-mappings/${id}`, { method: "DELETE" }),
};
